import type { Jsonifiable } from '../_shared';
import { SessionStorageBase } from '../_shared';

enum FormSessionStorageKey {
  PayflowBilling = 'payflow-billing-info-form',
}

export class FormValueSessionStorage extends SessionStorageBase {
  public loadPayflowBillingFormData(accountId?: number) {
    return this.load(this.getKey(FormSessionStorageKey.PayflowBilling, accountId));
  }

  public savePayflowBillingFormData(data: Jsonifiable, accountId?: number) {
    return this.save(this.getKey(FormSessionStorageKey.PayflowBilling, accountId), data);
  }

  public clearPayflowBillingFormData(accountId?: number) {
    return this.clear(this.getKey(FormSessionStorageKey.PayflowBilling, accountId));
  }
}

export const formValueSessionStorage = new FormValueSessionStorage();
